﻿import * as React from "react";
import Drawer from "material-ui/Drawer";
import { inject, observer } from "mobx-react";
import { observable, action } from "mobx"; 
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization } from "../../../models/localization";
import { Auth } from "../../../utils/auth";
import List, { ListItem, ListItemText } from "material-ui/List";
import LoginDlg from "../../dialogs/login";
import RegistrationDlg from "../../dialogs/registration";
import IconButton from "material-ui/IconButton";
import ArrowButton from "material-ui-icons/ArrowForward";
import BottomNavigation, { BottomNavigationAction } from 'material-ui/BottomNavigation';
import SvgIcon from "material-ui/SvgIcon";
import RestoreIcon from 'material-ui-icons/Restore';
import FavoriteIcon from 'material-ui-icons/Favorite';
import LocationOnIcon from 'material-ui-icons/LocationOn';
import { ScreenMode } from "../../../models/enums";
import Icon from "material-ui/Icon";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Button from "material-ui/Button";
import Divider from "material-ui/Divider";
import * as s from "./navbarMobile.css";
const styles: any = {
  icon: {
    height: "20px",
    width: "20px",
  },
  MuiIconButton: {
    color: "#5B6770",
  },
  root: {
    height: "56px",
    zIndex: 5,
  },
  label: {
    fontSize: "10px",
    minWidth: 0,
    whiteSpace: "nowrap",
    padding: 0,
    margin: 0,
    borderRadius: "2px",
  }
}

@inject("store") @observer
export default class NavBarMobile extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    if (Auth.isAuthenticated !== nextProps.isAuthenticated) {
      return true
    }
    if (Auth.isAuthenticated && this.props.store.viewState.scrollToRecommendedOps) {
      return true
    }
    return false
  }
  componentDidMount(): void {
    if (Auth.isAuthenticated) {
      this.setHighlightedTab();
    } else {
      document.getElementsByName("btmNav")[0].style.backgroundColor = "#0072CE40";
    }
  }
  componentDidUpdate(): void {
    if (Auth.isAuthenticated) {
      this.setHighlightedTab();
    } else {
      document.getElementsByName("btmNav")[0].style.backgroundColor = "#0072CE40";
    }
  }
  setHighlightedTab = (): void => {
    const location: string = window.location.hash
    let index: number = -1;
    switch (location) {
      case "#/#/home":
        index = 1;
        break;
      case "#/home":
        index = 1;
        break;
      case "#/profile":
        index = 0;
        break;
      case "#/profile/saved-ops":
        index = 2;
        break;
    }
    for (let c = 0; c < 4; c++) {
      document.getElementsByName("btmNav")[c].style.backgroundColor = "#FFF";
    }
    if (index > -1) {
      document.getElementsByName("btmNav")[index].style.backgroundColor = "#0072CE40";
    }
  }

  handleChange = (event, value) => {
    for (let c = 0; c < 4; c++) {
      document.getElementsByName("btmNav")[c].style.backgroundColor = "#FFF";
    }
    document.getElementsByName("btmNav")[value].style.backgroundColor = "#0072CE40";

    if (value === 3) {
      this.props.store.viewState.setScrollToSearchBar(true);
      hashHistory.push("/home");
    }
  };

  goToSearchBar = (): void => {
    this.props.store.viewState.setScrollToSearchBar(true);
    hashHistory.push("/home");
  }

  renderMobile(): JSX.Element[] {
    const value = this.state;
    let items: JSX.Element[] = [];
    const local: ILocalization = this.props.store.localization.fields;
    if (Auth.isAuthenticated) {
      items.push(<BottomNavigation key="bottom-nav" value={value} onChange={this.handleChange} showLabels style={styles.root} className={s.navbar}>
        <BottomNavigationAction name="btmNav" key="bottom-nav-profile"
          onClick={() => hashHistory.push("/profile")}
          style={styles.label} label={local.sideNav.profile}
          color="secondary" icon={<Icon style={styles.MuiIconButton} aria-label="profile-page"><img src={local.icons.profile} style={styles.icon} /></Icon>} />
        <BottomNavigationAction name="btmNav" key="bottom-nav-home"  onClick={() => hashHistory.push("/home")} style={styles.label} label={local.sideNav.home} color="secondary" icon={<Icon style={styles.MuiIconButton} aria-label="home-page"><img src={local.icons.home} style={styles.icon} /></Icon>} />
        <BottomNavigationAction name="btmNav" key="bottom-nav-saved"  onClick={() => hashHistory.push("/profile/saved-ops")} label={local.sideNav.saved} color="secondary" style={styles.label} icon={<Icon style={styles.MuiIconButton} aria-label="saved-page"><img src={local.icons.savedStar} style={styles.icon} /></Icon>} />
        <BottomNavigationAction name="btmNav" key="bottom-nav-search"  label={local.sideNav.search} color="secondary" style={styles.label} icon={<Icon style={styles.MuiIconButton} aria-label="search-page"><img src={local.icons.search} style={styles.icon} /></Icon>} />
        </BottomNavigation>);
    } else {
      items.push(<BottomNavigation key="bottom-nav" showLabels style={styles.root} className={s.navbar}>
        <BottomNavigationAction name="btmNav" key="bottom-nav-home" onClick={() => hashHistory.push("/home")} label={local.sideNav.home} style={styles.label} color="secondary" icon={<Icon style={styles.MuiIconButton} aria-label="home-page"><img src={local.icons.home} style={styles.icon} /></Icon>} />
      </BottomNavigation>);
    }
    return items;
  }



  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    return <div>
      {mode === ScreenMode.Mobile && this.renderMobile()}
    </div>

  }
}


// WEBPACK FOOTER //
// ./src/components/app/navbarMobile/index.tsx